import React from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {gt} from 'app/utils/i18n';

import {
  selectIsHidingDeletedComments,
  toggleIsHidingDeletedComments,
} from '../slice';

interface Props {
  show: boolean;
}

export function HideDeletedCommentsCheckbox({show}: Props) {
  if (!show) {
    return null;
  }
  const dispatch = useDispatch();
  const isHidingDeletedComments = useSelector(selectIsHidingDeletedComments);

  return (
    <div id="hide_comments" className="m-1 ml-2 bg-white">
      <input
        type="checkbox"
        id="exclude_deleted_comments"
        className="mr-1 align-middle"
        checked={isHidingDeletedComments}
        onChange={() => dispatch(toggleIsHidingDeletedComments())}
      />
      <label htmlFor="exclude_deleted_comments" className="m-0">
        <small>{gt('Hide deleted')}</small>
      </label>
    </div>
  );
}
